import { render, staticRenderFns } from "./user_edit.vue?vue&type=template&id=e8135d36&scoped=true&"
import script from "./user_edit.vue?vue&type=script&lang=js&"
export * from "./user_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8135d36",
  null
  
)

export default component.exports